module.exports = __webpack_public_path__ + "img/icon2.c77699b3.jpg";